import React, { useMemo, useState, useEffect } from "react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";

import { filterFields } from "../../utils/search";
import FieldSectionAccordion from "./FieldSectionAccordion";

const GroupedFieldsView = ({ fieldSections, search, component: Checkbox, categoryEnabled }) => {
  const { values } = useFormikContext();
  const [expandedSections, setExpandedSections] = useState({});

  const processedSections = useMemo(() => {
    return fieldSections
      .map(({ key, title, fields }) => {
        const filteredFields = filterFields(fields, search);
        const checkedCount = filteredFields.filter(([name, category]) => {
          return categoryEnabled ? values[category]?.[name] : values[name];
        }).length;
        return {
          key,
          title,
          fields: filteredFields,
          checkedCount,
        };
      })
      .filter(section => section.fields.length > 0);
  }, [fieldSections, search, values]);

  useEffect(() => {
    const hasSearch = search && search.trim() !== "";
    const newExpandedState = {};

    processedSections.forEach(({ key }) => {
      newExpandedState[key] = hasSearch;
    });

    setExpandedSections(newExpandedState);
  }, [search]);

  const handleAccordionChange = sectionKey => (event, isExpanded) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionKey]: isExpanded,
    }));
  };

  if (processedSections.length === 0) return null;

  return (
    <Box sx={{ width: "100%" }}>
      {processedSections.map(({ key, title, fields, checkedCount }) => (
        <FieldSectionAccordion
          key={key}
          sectionKey={key}
          title={title}
          fields={fields}
          checkedCount={checkedCount}
          expanded={expandedSections[key] || false}
          onChange={handleAccordionChange(key)}
          component={Checkbox}
        />
      ))}
    </Box>
  );
};

export default GroupedFieldsView;
